import { snapshot } from "valtio";
import store from "@/store";
import themeSort from "@/components/Theme/ThemeEditor/mapper/themeSort";


const updateOriginalFromCurrent = (single?: boolean) => {
    const { selectedTheme } = snapshot(store);
    const { selectedElementId, currentElements } = selectedTheme;

    if (selectedTheme && currentElements && currentElements) {


        const updated = single
            ? currentElements.filter(el => el.id === selectedElementId)
            : currentElements;

        const updatedElements = updated.map(el => ({
            ...el,
            hints: el.hints?.slice() || [],
            status: 'saved' as const
        }));

        const updateForOriginalElement = themeSort([
            ...store.selectedTheme.originalElements.filter(
                ori => !updatedElements.find(el => el.id === ori.id)
            ),
            ...updatedElements
        ]);

        const updateForCurrentElement = themeSort([
            ...store.selectedTheme.currentElements.filter(
                ori => !updatedElements.find(el => el.id === ori.id)
            ),
            ...updatedElements
        ]);


        store.selectedTheme.originalElements = [...updateForOriginalElement];
        store.selectedTheme.currentElements = [...updateForCurrentElement];


        // handle Main Css if exists
        /*const mainCss = currentElements.find(el => el.name === 'Main Css');
        if (mainCss) {
            const index = store.selectedTheme.originalElements.findIndex(el => el.name === 'Main Css');
            const savedMainCss = {
                ...mainCss,
                hints: mainCss.hints?.slice() || [],
                status: 'saved' as const
            };
            if (index >= 0) {
                store.selectedTheme.originalElements[index] = {...savedMainCss};
                store.selectedTheme.currentElements[index] = {...savedMainCss};
            } else {
                store.selectedTheme.originalElements.push({...savedMainCss});
                store.selectedTheme.currentElements.push({...savedMainCss});
            }
        }*/
        //console.log("satart update", mainCss, updated, updatedElements)
    }
};

export default updateOriginalFromCurrent;
